import { axiosMockAdapterInstance as mock } from '../axiosInstance';

const mockDefault = mock
  .onAny().passThrough();

export { mockDefault }